import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dosDigitos'
})
export class DosDigitosPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value == null) return '00';
    return value.toString().padStart(2, '0');
  }
}
